import React, { useEffect, useState } from 'react';
import { PhoneCall, Menu, X } from 'lucide-react';
import logo from '../../Assets/RDS ENCLAVE@300x-8.png';
import slide1 from '../../Assets/original/home.JPG';
import slide from '../../Assets/slide1.jpg';
import { Link } from 'react-router-dom';
import ContactModal from '../UI/ContactModal'; // adjust path

const Home = () => {
  const slides = [slide, slide1];
  const [currentSlide, setCurrentSlide] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);

useEffect(() => {
  const interval = setInterval(() => {
    setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
  }, 3000); // Change timing as needed
  return () => clearInterval(interval);
}, [slides.length]);

  return (
    <div className="relative">
      {/* Hero Slide */}
<div className="relative md:h-screen h-[130px] overflow-hidden">
  <div
    className="flex transition-transform duration-1000 ease-in-out"
    style={{ transform: `translateX(-${currentSlide * 100}%)` }}
  >
    {slides.map((slideImage, index) => (
      <div key={index} className="w-full flex-shrink-0 h-[130px] md:h-screen">
        <img
          src={slideImage}
          alt={`Slide ${index}`}
          className="w-full h-full object-cover"
        />
      </div>
    ))}
  </div>
        {/* Header */}
        <header className="absolute top-0 left-0 w-full flex justify-between items-center p-2 z-50">
          <Link to="/">
            <img src={logo} alt="Logo" className="h-12 sm:h-24 w-auto md:block hidden" />
          </Link>

          {/* Desktop Links */}
          <div className="hidden sm:flex items-center gap-4 text-black">
            <Link to="/about">
              <button className="text-black font-medium text-lg">About Us</button>
            </Link>
            <Link to="/projects" className="block px-4 py-2 text-black font-medium text-lg  " onClick={() => setMenuOpen(false)}>
                       Our Projects
                     </Link>
            <button
              onClick={() => setShowContactModal(true)}
              className="text-black font-medium text-lg border border-black px-4 py-1 rounded hover:bg-black hover:text-white"
            >
              Contact Us
            </button>
          </div>

          {/* Call Icon + Mobile Menu */}
          <div className="flex items-center gap-2 sm:hidden">
            <div className="w-8 h-8 bg-white/20 border border-black rounded-full flex items-center justify-center">
              <PhoneCall className="text-black" />
            </div>
            <div
              className="w-8 h-8 bg-white/20 border border-black rounded-full flex items-center justify-center"
              onClick={() => setMenuOpen(!menuOpen)}
            >
              {menuOpen ? <X className="text-black" size={20} /> : <Menu className="text-black" />}
            </div>
          </div>
        </header>
      </div>

      {/* Slide Dots */}
      <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 flex gap-2 z-40">
        {slides.map((_, index) => (
          <div
            key={index}
            className={`px-3 py-0.5 rounded-xl transition-all duration-300 ${
              currentSlide === index ? 'bg-gray-300' : 'bg-gray-900'
            }`}
          ></div>
        ))}
      </div>

      {/* Mobile Dropdown Menu */}
      {menuOpen && (
        <div className="absolute top-20 right-4 bg-white text-black shadow-md rounded-lg py-2 w-48 z-50 sm:hidden">
          <Link to="/about" className="block px-4 py-2 hover:bg-gray-100" onClick={() => setMenuOpen(false)}>
            About Us
          </Link>
          <Link to="/projects" className="block px-4 py-2 hover:bg-gray-100" onClick={() => setMenuOpen(false)}>
            Our Projects
          </Link>
          <button className="block w-full text-left px-4 py-2 hover:bg-gray-100" onClick={() => {
            setShowContactModal(true);
            setMenuOpen(false);
          }}
          >
            Contact Us
          </button>
        </div>

      )}
      {/* Contact Modal */}
<ContactModal isOpen={showContactModal} onClose={() => setShowContactModal(false)} />
  
    </div>
  );
};

export default Home;
